export default "__VITE_ASSET__Dfn8GolU__"